import Swiper, { EffectFade, Lazy, Navigation } from "swiper";
import WooCommon from "./woo-common";

const VariationsForm = {
  element: $(".variations-form"),

  init() {
    VariationsForm.events();
  },

  events() {
    /**
     * Open form
     */
    $("body").on("click", ".add-to-cart-simple", function () {
      $(this).addClass("loading").removeClass("added");
      VariationsForm.simple($(this));
    });

    /**
     * Open form
     */
    $("body").on("click", ".add-to-cart-variable", function () {
      const product_id = $(this).attr("data-product");

      $(".variation-form").addClass("form-open");
      $("html").addClass("no-scroll");
      $(".preloader").addClass("preloader--show");

      VariationsForm.render(product_id);
    });
    /**
     * Close form
     */
    $("body").on("click", ".close-variations-form", function (e) {
      e.preventDefault();
      VariationsForm.close();
    });
  },

  /**
   * Form Close
   **/
  close() {
    $(".variation-form").removeClass("form-open");
    $(".variation-form").find("#variations-content").html("");
    $("html").removeClass("no-scroll");
  },

  /**
   * Form Loaded
   **/
  loaded() {
    const wrapEl = $(".preview-attribute");
    if (!wrapEl.length) {
      return;
    }

    $(".preview-attribute").each((_i, el) => {
      const wrapEl = $(el);
      const swiperEl = wrapEl.find(".swiper");
      const slider = new Swiper(swiperEl[0], {
        loop: false,
        slidesPerView: 1,
        modules: [Navigation, EffectFade],
        effect: "fade",
        navigation: {
          prevEl: wrapEl.find(".swiper-button--prev")[0],
          nextEl: wrapEl.find(".swiper-button--next")[0],
        },
        on: {
          init: (e) => {
            let index_currentSlide = e.realIndex;
            let currentSlide = e.slides[index_currentSlide];
            const term = $(currentSlide).attr("data-term");
            const value = $(currentSlide).attr("data-id");
            const attrPrice = $(currentSlide).find(".attr-price").html();

            $(`#${term}`).val(value).change();

            const option = {
              term: term,
              label: term.replace("pa_", ""),
              value: value,
              price: attrPrice,
            };
            VariationsForm.renderOptions(option);
          },
        },
      });

      VariationsForm.setVariation();

      slider.on("slideChange", (e) => {
        let index_currentSlide = e.realIndex;
        let currentSlide = e.slides[index_currentSlide];
        const term = $(currentSlide).attr("data-term");
        const value = $(currentSlide).attr("data-id");
        const attrPrice = $(currentSlide).find(".attr-price").html();

        $(`#${term}`).val(value).change();

        const option = $(`[data-option-term=${term}]`);

        $(option).find(".variations-form-options__item--value").html(value);
        $(option).find(".variations-form-options__item--price").html(attrPrice);

        VariationsForm.setVariation();
      });
    });
  },

  /**
   * Set current variation ID and display selected options with variation price
   **/
  setVariation() {
    let optionsArray = {};

    const currentSelectedOptions = $(".variations_form").find("select");

    currentSelectedOptions.each((_i, el) => {
      const attrName = $(el).attr("data-attribute_name");
      optionsArray[attrName] = el.value;
    });

    const variations = $(".variations_form").attr("data-product_variations");

    const variationsObj = JSON.parse(variations);

    variationsObj.forEach((item) => {
      if (JSON.stringify(item.attributes) === JSON.stringify(optionsArray)) {
        //console.log(item);
        $("#variationPrice").html(item.display_price + ` €`);
        $(".variation_id").val(item.variation_id);
      }
    });
  },

  renderOptions(option) {
    $("#variationOptions").append(`
      <div class="variations-form-options__item" data-option-term="${option.term}">
        <p class="variations-form-options__item--label">${option.label}</p>
        <div class="variations-form-options__item--row">
          <span class="variations-form-options__item--value">${option.value}</span>
          <span class="variations-form-options__item--price">${option.price}</span>
        </div>
      </div>
    `);
  },

  simple(btnEl) {
    const product_id = btnEl.attr("data-product");

    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "render_variations_form",
        product_id,
      },
    })
      .done((response) => {
        if (!response.popup) {
          btnEl.children("span").text(translations.added_to_cart);
          btnEl.addClass("added");
          WooCommon.header.get_cart_count();
          $(".quick-cart").removeClass("quick-cart--loaded");
        }
      })
      .always(() => {
        btnEl.removeClass("loading");
      });
  },

  render(product_id) {
    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "render_variations_form",
        product_id,
      },
    }).done((response) => {
      if (response.popup && response.html) {
        $(".preloader").removeClass("preloader--show");
        $("#variations-content").html(response.html);
        setTimeout(() => {
          VariationsForm.loaded();
        }, 100);
      } else {
        VariationsForm.close();
      }
    });
  },
};

export default VariationsForm;
